import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { PaymentResult } from "../../_shared/models/PaymentResult";
import { WebApiService } from "../WebApiService";


export class FiltersController {
  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }
  checkAll(userId:string, lotteryId: string, search: string, filterGroupId: any, isChecked: boolean): Promise<any> {

    let body = {
      userId: userId, lotteryId: lotteryId, search: search, filterGroupId: filterGroupId, isChecked: isChecked
    };

    return this._http.post(this._webApi.GetApiAddress() + `/filters/checkAll`,body, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

      
  }

  removeAll(userId:string, lotteryId: string, search: string, filterGroupId: any, isChecked: number): Promise<any> {

    let body = {
      userId: userId, lotteryId: lotteryId, search: search, filterGroupId: filterGroupId, isChecked: isChecked
    };

    return this._http.post(this._webApi.GetApiAddress() + `/filters/removeAll`,body, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

      
  }

  recalcGroups(userId:string, lotteryId: string): Promise<any> {

    let body = {
      userId: userId, lotteryId: lotteryId
    };

    return this._http.post(this._webApi.GetApiAddress() + `/filters/recalcGroups/${userId}/${lotteryId}`,body, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

      
  }


}
